import { Component, inject, OnInit } from '@angular/core';
import { FindMoneyService } from '../find-money.service';
import { PartnerDetails } from '@brightside-web/desktop/data-access/shared';
import { ActionCardConfigInterface, BrightsideUiModule } from '@brightside/brightside-ui';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { animate, style, transition, trigger } from '@angular/animations';
import { interval, Subscription } from 'rxjs';

@Component({
    selector: 'brightside-web-find-money-home-feed',
    templateUrl: './find-money-home-feed.component.html',
    styleUrls: ['./find-money-home-feed.component.scss'],
    imports: [BrightsideUiModule, CommonModule],
    animations: [
        trigger('slide', [
            transition(':enter', [
                style({ transform: '{{enterTransform}}', opacity: 0 }),
                animate('400ms ease-out', style({ transform: 'translateX(0)', opacity: 1 }))
            ], { params: { enterTransform: 'translateX(100%)' } }),
            transition(':leave', [
                animate('400ms ease-out', style({ transform: '{{leaveTransform}}', opacity: 0 }))
            ], { params: { leaveTransform: 'translateX(-100%)' } })
        ])
    ]
})
export class FindMoneyHomeFeedComponent implements OnInit {
  findMoneyData: PartnerDetails[] = [];
  currentIndex = 0;
  animationState: any = { value: '', params: { enterTransform: 'translateX(100%)', leaveTransform: 'translateX(-100%)' } };
  private _router = inject(Router);
  private _sub = new Subscription();

  constructor(private findMoneyService: FindMoneyService) {}

  ngOnInit() {
    this._sub.add(
      this.findMoneyService.findMoneyData$.subscribe((partners: PartnerDetails[]) => {
        this.findMoneyData = partners;
        this.currentIndex = 0;
      })
    );
  }

  ngOnDestroy() {
    this._sub.unsubscribe();
  }

  mapToCardConfig(partner: PartnerDetails): ActionCardConfigInterface {
    return this.findMoneyService.mapToCardConfig(partner);
  }

  onCtaClicked(partner: PartnerDetails) {
    this._router.navigate(['find-money', 'intro', partner.key]);
  }


  next() {
    this.animationState = 'left';
    this.currentIndex = (this.currentIndex + 1) % this.findMoneyData.length;
  }

  prev() {
    this.animationState = 'right';
    this.currentIndex =
      (this.currentIndex - 1 + this.findMoneyData.length) % this.findMoneyData.length;
  }

  goTo(index: number) {
    if (index > this.currentIndex) {
      this.animationState = 'left';
    } else if (index < this.currentIndex) {
      this.animationState = 'right';
    }
    this.currentIndex = index;
  }

  resetAnimationState() {
    this.animationState = '';
  }



}
